module.exports = __webpack_public_path__ + "img/player_mark.855e15dc.svg";